import React, { useEffect, useState } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import axios from "axios";
import Notiflix from "notiflix";
import { Helmet } from "react-helmet-async";
import img from "../images/Web-developer.svg";

const jobs = [
  {
    id: 1,
    title: "React Developer",
    vacancy: 2,
    description:
      "Responsible for developing dynamic, responsive, and high-performance web applications using React.js.",
    location: "Surat, Gujarat",
    workType: "WFO",
    positionType: "Contractual + Permanent",
    requirements: [
      "1 to 2  years of experience in JavaScript and React.js.",
      "Strong problem-solving and debugging skills.",
      "Have some knowledge of Nextjs and Remix.",
      "Experience with Redux and other state management tools.",
      "Familiarity with RESTful APIs and third-party libraries.",
      "Knowledge of modern frontend development tools like Webpack, Babel, and ESLint.",
    ],
  },

  {
    id: 4,
    title: "Backend Developer",
    vacancy: 1,
    description:
      "Build and maintain efficient, scalable, and secure server-side applications and APIs.",
    location: "Surat, Gujarat",
    workType: "WFO",
    positionType: "Permanent",
    requirements: [
      "1+ years of professional experience in backend development.",
      "Strong knowledge of Node.js and MongoDB,sql.",
      "Experience with RESTful API design and development.",
      "Understanding of server-side frameworks like Express.js.",
      "Knowledge of database schema design and optimization.",
    ],
  },
  {
    id: 5,
    title: "Business Development Executive (BDE)",
    vacancy: 1,
    description:
      "Identify, develop, and manage new business opportunities and client relationships to drive company growth.",
    location: "Surat, Gujarat",
    workType: "WFO",
    positionType: "Contractual",
    requirements: [
      "2+ year of experience required",
      "Proven experience in sales or business development.",
      "Excellent communication and negotiation skills.",
      "Ability to identify and build relationships with potential clients.",
      "Familiarity with CRM tools and lead generation platforms.",
      "Strong analytical and problem-solving skills.",
    ],
  },
];

const Career = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useDocTitle("TeqnoDux | Careers");

  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({
    candidateName: "",
    currentSalary: "",
    expectedSalary: "",
    contactNumber: "",

    noticePeriod: "",
    linkedinLink: "",
    experience: "",
    message: "",
    cvFile: null,
  });
  const [errors, setErrors] = useState({});

  const handleApply = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedJob(null);
    setFormData({
      candidateName: "",
      currentSalary: "",
      expectedSalary: "",
      contactNumber: "",
      noticePeriod: "",
      linkedinLink: "",
      experience: "",
      message: "",
      cvFile: null,
    });
    setErrors({});
  };

  const validateField = (name, value) => {
    let error = "";
    if (name === "currentSalary" || name === "expectedSalary") {
      if (!value) {
        error = "This field is required.";
      } else if (!/^\d+$/.test(value)) {
        error = "Must be a valid number.";
      } else if (value.length > 10) {
        error = "Must be less than or equal to 10 digits.";
      }
    } else if (name === "contactNumber") {
      if (!value) {
        error = "This field is required.";
      } else if (!/^\d{10}$/.test(value)) {
        error = "Must be exactly 10 digits.";
      }
    } else if (name === "candidateName" || name === "noticePeriod") {
      if (!value) {
        error = "This field is required.";
      }
    } else if (name === "experience") {
      if (!value) {
        error = "This field is required.";
      } else if (!/^\d+$/.test(value)) {
        error = "Must be a valid number.";
      }
    } else if (name === "cvFile") {
      if (!value) {
        error = "Please upload your CV/Resume.";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    const fieldValue = files ? files[0] : value;

    setFormData({ ...formData, [name]: fieldValue });

    // Validate field as user types or uploads a file
    const error = validateField(name, fieldValue);
    setErrors({ ...errors, [name]: error });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({}); // Clear any previous errors

    // Validate fields
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Disable the submit button and show loading
    const submitButton = document.getElementById("submitApplicationBtn");
    submitButton.disabled = true;
    submitButton.innerHTML = "Sending...";

    // Prepare form data for API submission
    const fData = new FormData();
    fData.append("candidate_name", formData.candidateName);
    fData.append("current_salary", formData.currentSalary);
    fData.append("expected_salary", formData.expectedSalary);
    fData.append("contact_number", formData.contactNumber);
    fData.append("notice_period", formData.noticePeriod);
    fData.append("linkedin_link", formData.linkedinLink || "");
    fData.append("experience", formData.experience);
    fData.append("message", formData.message);
    fData.append("appliedfor", selectedJob.title);
    if (formData.cvFile) {
      fData.append("cv_file", formData.cvFile);
    }

    // console.log("FormData contents:");
    // for (let [key, value] of fData.entries()) {
    //   console.log(`${key}:`, value);
    // }
    debugger;

    // Send data to the server
    axios({
      method: "post",
      url: `${process.env.REACT_APP_CONTACT_API}/api/apply`, // Replace with your API endpoint
      data: fData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        submitButton.disabled = false;
        submitButton.innerHTML = "Submit Application";
        closeModal(); // Close the modal and reset form
        Notiflix.Report.success("Success", response.data.message, "Okay");
      })
      .catch((error) => {
        submitButton.disabled = false;
        submitButton.innerHTML = "Submit Application";

        const { response } = error;
        if (response?.status === 500) {
          Notiflix.Report.failure(
            "An error occurred",
            response?.data?.message || "Internal Server Error",
            "Okay"
          );
        }
        if (response?.data?.errors) {
          setErrors(response.data.errors); // Show field-specific errors if available
        }
      });
  };

  return (
    <>
      <Helmet>
        <title>TeqnoDux | Careers</title>
        <meta name="description" content="Careers" />
        <meta property="og:title" content="TeqnoDux | Careers" />
        <meta
          property="og:description"
          content="TeqnoDux specializes in innovative software development craftsmanship, delivering tailored solutions to empower your business."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="teqnoduxlogo.jpg" />
        <meta property="og:url" content="https://teqnodux.com/career" />
        <meta property="og:site_name" content="TeqnoDux" />
        <link rel="canonical" href="https://teqnodux.com/career" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "TeqnoDux",
            description:
              "TeqnoDux is a global leader in software development, delivering high-quality, custom software solutions tailored to your needs. Explore our innovative services!",
            provider: {
              "@type": "Organization",
              name: "TeqnoDux",
              url: "https://teqnodux.com/career",
            },
            serviceType: [
              "Web Development",
              "Mobile App Development",
              "CRM Consulting",
              "3D Web Solutions",
            ],
            areaServed: "Worldwide",
            image: img,
            url: "https://teqnodux.com/career",
          })}
        </script>
      </Helmet>
      <NavBar />
      <div
        className="container mx-auto my-12 px-4 lg:px-20 sm:mt-32 mt-32"
        data-aos="zoom-in"
      >
        <h1
          id="career"
          className="font-bold text-center text-[#377c7d] uppercase sm:text-4xl text-3xl"
        >
          Join Our Team
        </h1>
        <p className="text-center text-gray-700 mt-4">
          Explore our open positions and apply to become part of our growing
          team.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          {jobs.map((job) => (
            <div
              key={job.id}
              className="p-6 border rounded-lg shadow-md hover:shadow-xl transition-shadow"
            >
              <h2 className="sm:text-2xl text-xl font-bold text-[#377c7d]">
                {job.title} - {job.vacancy}
              </h2>
              <p className="text-gray-600 mt-2">{job.description}</p>
              <p className="text-gray-500 mt-2">
                <strong>Location:</strong> {job.location}
              </p>
              <p className="text-gray-500 mt-2">
                <strong>Work Type:</strong> {job.workType}
              </p>
              <p className="text-gray-500 mt-2">
                <strong>Position Type:</strong> {job.positionType}
              </p>
              <ul className="list-disc list-inside mt-4">
                {job.requirements.map((req, index) => (
                  <li key={index} className="text-gray-700">
                    {req}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handleApply(job)}
                className="mt-4 bg-[#377c7d] text-white py-2 px-4 rounded-lg hover:bg-[#2b6262]"
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* WHY CHOOSE US Section */}
      <div className="bg-white py-16 px-4 text-center">
        <h2 className="sm:text-4xl text-3xl font-bold text-[#081a33] mb-4">
          Why <span className="text-[#377c7d]">Choose Us?</span>
        </h2>
        <p className="text-gray-700 sm:text-lg text-base max-w-3xl sm:mx-auto mx-4 mb-8">
          At TeqnoDux, we pride ourselves on cultivating a supportive and
          vibrant workplace culture. Our team thrives in a collaborative and
          positive environment where every voice is valued. With a
          non-hierarchical approach and open communication, we ensure a work
          atmosphere that is both engaging and empowering.
        </p>
        <p className="text-gray-700 sm:text-lg text-base max-w-3xl  mb-8 sm:mx-auto mx-4">
          The friendly and favorable work environment motivates the employees to
          work harder. We can assure you that we would never let you down when
          you join hands with us. We are always there to lend a helping hand and
          help you build effective career and professional growth.
        </p>
        <p className="text-lg font-bold text-gray-900">
          Join us and be a part of the team! You can mail your resume at{" "}
          <a href="mailto:info@teqnodux.com" className="text-[#377c7d]">
            info@teqnodux.com
          </a>
        </p>
      </div>
      {/* Modal */}
      {showModal && selectedJob && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-full max-w-lg p-8 rounded-lg shadow-lg overflow-y-auto max-h-[90vh]">
            <h2 className="text-2xl font-bold text-[#377c7d] mb-4">
              Apply for {selectedJob.title}
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 gap-4">
                <input
                  type="text"
                  name="candidateName"
                  placeholder="Candidate Name*"
                  value={formData.candidateName}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.candidateName ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.candidateName && (
                  <p className="text-red-500 text-sm">{errors.candidateName}</p>
                )}
                <input
                  type="number"
                  name="currentSalary"
                  placeholder="Current Salary*"
                  value={formData.currentSalary}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.currentSalary ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.currentSalary && (
                  <p className="text-red-500 text-sm">{errors.currentSalary}</p>
                )}
                <input
                  type="number"
                  name="expectedSalary"
                  placeholder="Expected Salary*"
                  value={formData.expectedSalary}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.expectedSalary ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.expectedSalary && (
                  <p className="text-red-500 text-sm">
                    {errors.expectedSalary}
                  </p>
                )}
                <input
                  type="text"
                  name="contactNumber"
                  placeholder="Contact Number*"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.contactNumber ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.contactNumber && (
                  <p className="text-red-500 text-sm">{errors.contactNumber}</p>
                )}
                <input
                  type="text"
                  name="noticePeriod"
                  placeholder="Notice Period*(in days)"
                  value={formData.noticePeriod}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.noticePeriod ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.noticePeriod && (
                  <p className="text-red-500 text-sm">{errors.noticePeriod}</p>
                )}
                <input
                  type="url"
                  name="linkedinLink"
                  placeholder="LinkedIn Link (optional)"
                  value={formData.linkedinLink}
                  onChange={handleChange}
                  className="border border-gray-300 p-2 rounded"
                />
                <input
                  type="number"
                  name="experience"
                  placeholder="Experience* (in years)"
                  value={formData.experience}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.experience ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.experience && (
                  <p className="text-red-500 text-sm">{errors.experience}</p>
                )}
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="border border-gray-300 p-2 rounded"
                ></textarea>
                <input
                  type="file"
                  name="cvFile"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    errors.cvFile ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.cvFile && (
                  <p className="text-red-500 text-sm">{errors.cvFile}</p>
                )}
              </div>
              <div className="mt-4 flex justify-between">
                <button
                  type="button"
                  onClick={closeModal}
                  className="bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  id="submitApplicationBtn"
                  type="submit"
                  className="bg-[#377c7d] text-white py-2 px-4 rounded-lg hover:bg-[#2b6262]"
                >
                  Submit Application
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Career;
